import React from 'react'

import { Title, Text } from 'components/typo'
import Image from 'components/shared/Image'

import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const StoriesCardContent = ({
  className,
  logo,
  title,
  label,
  forwardRef,
  isList,
}) => {
  return (
    <div
      ref={forwardRef}
      className={cx(css.StoriesCardContent, className, { isList })}
    >
      {logo && (
        <Image className={css.logo} forcedRatio={0.4} fit="contain" {...logo} />
      )}

      {label && !isList && (
        <Title className={css.label} size="smaller">
          {label}
        </Title>
      )}
      {title && isList ? (
        <Title className={css.title} size="smaller">
          {title}
        </Title>
      ) : (
        <Text className={css.description} theme="gray" size="small">
          {title}
        </Text>
      )}
    </div>
  )
}

export default StoriesCardContent
